import {
  ICalendarDayAvailability,
  ICalendarMonthAvailability,
  ICalendarPriceGroup,
} from "~/types/api-types";

import { ApiError } from "./api-error";

export const fetchMonthAvailability = async ({
  isOwner = false,
  spaceId = "",
  month,
  year,
}: {
  isOwner?: boolean;
  spaceId: string;
  month: number;
  year: number;
}): Promise<ICalendarMonthAvailability> => {
  const response = await fetch(
    `/v1/calendar/bookings${isOwner ? "/host" : ""}/availability/space/${spaceId}/month?month=${month}&year=${year}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    },
  );

  if (!response.ok) {
    const errorData = await response.json();
    throw new ApiError(
      errorData.message || "Failed to fetch calendar availability",
      response.status,
    );
  }

  return response.json();
};

export const fetchDayAvailability = async ({
  listingId,
  selector,
  isOwner = false,
  spaceId = "",
  month,
  year,
  day,
  startTimeIndex,
  enforceMinimumHours = false,
}: {
  listingId: string;
  selector: "start" | "end";
  isOwner?: boolean;
  spaceId: string;
  month: number;
  year: number;
  day: number;
  startTimeIndex?: number;
  enforceMinimumHours: boolean;
}): Promise<ICalendarDayAvailability> => {
  const response = await fetch(
    `/v1/calendar/bookings${isOwner ? "/host" : ""}/availability/space/${spaceId}/day/${selector}?listing_id=${listingId}&month=${month}&year=${year}&day=${day}${startTimeIndex ? `&time_index=${startTimeIndex}` : ""}${enforceMinimumHours ? "&is_min_duration_test_group=true" : ""}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    },
  );

  if (!response.ok) {
    const errorData = await response.json();
    throw new ApiError(
      errorData.message || "Failed to fetch calendar availability",
      response.status,
    );
  }

  return response.json();
};

export const fetchCalendarPricing = async (
  accessToken: string,
  listingId: string,
): Promise<ICalendarPriceGroup[]> => {
  const response = await fetch(
    `/v2/spaces-v2/listings/${listingId}/calendar-pricing`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    },
  );
  if (!response.ok) {
    const errorData = await response.json();
    throw new ApiError(
      errorData.message || "Failed to read calendar",
      response.status,
    );
  }

  const data = await response.json();
  return data?.prices_by_group || [];
};
